import { getAccessToken, getUserId, getCompanyId, getLiteCompanyId } from "./utils";

export const getUrl = (key, IDBRequest) => {
    // let staging = false;
    // if (
    //     document.location.origin.indexOf("20twentystage") > -1 ||
    //     document.location.origin.indexOf("20twentyradarstage") > -1 ||
    //     document.location.origin.indexOf("radarrstage") > -1 ||
    //     document.location.origin.indexOf("appstage") > -1 ||
    //     document.location.origin.indexOf("appdev") > -1 ||
    //     document.location.origin.indexOf("appdev1") > -1 ||
    //     document.location.origin.indexOf("appdev2") > -1 ||
    //     document.location.hostname === "localhost"
    // ) {
    //     staging = true;
    // } else {
    //     staging = false;
    // }
    return getNodejsUrls(key);
};

const getNodejsUrls = (key) => {
    // if(key==='meta_api') {
    //   return 'http://13.228.18.45:3002/v1/meta?access-token='+ getAccessToken();
    // } else if (key ==='searchaggs') {
    //   return 'http://13.228.18.45:3002/v1/search?access-token=' + getAccessToken();
    // } else if (key==='raw_data') {
    //   return 'http://13.228.18.45:3002/v1/search?access-token=' + getAccessToken();
    // }

    let urls = {
        filter_expand: `v7/toggle-filters?access-token=${getAccessToken()}`,
        notif_counter: `${"v7/notification-service/counter?access-token=" + getAccessToken()}`,
        notif_counter_clear: `${"v7/notification-service/web/counter/clear?access-token=" + getAccessToken()}`,
        meta_api: `${"v7/meta?access-token=" + getAccessToken()}`,
        public_meta_api: `${"v7/meta/public?access-token=" + getAccessToken()}`,
        access_token_facebook: `${"v7/access-token-facebook?access-token=" + getAccessToken()}`,
        access_token_instagram: `${"v7/access-token-instagram?access-token=" + getAccessToken()}`,
        volOfConvSubtopicsCount: `v7/volume-of-conversation-subtopics-count-with-overall?access-token=${getAccessToken()}`,
        pubTimeseries: `v7/volume-of-conversation-subtopics?access-token=${getAccessToken()}`,
        mentionTimeseries: `v7/volume-of-conversation-subtopics-count-daywise?access-token=${getAccessToken()}`,
        mentionTimeseriesOverAll: `v7/volume-of-conversation-subtopics-count-daywise-overall?access-token=${getAccessToken()}`,
        update_filter: `v7/meta/filters/update?access-token=${getAccessToken()}`,
        add_filter: `v7/meta/filters/add?access-token=${getAccessToken()}`,
        delete_filter: `v7/meta/filters/delete?access-token=${getAccessToken()}`,
        raw_data: `v7/search?access-token=${getAccessToken()}`,
        irrelevant_post: `v1/meta/update-record`,
        bulk_mark_irr_update: `v1/meta/update-record`,
        sentiment_update: `v1/meta/update-record`,
        all_update: `v7/bulk-update-queue?access-token=${getAccessToken()}`,
        searchaggs: `v7/search?access-token=${getAccessToken()}`,
        topicWiseSentimentBreakup: `v7/sub-topic-wise-sentiments-breakup?access-token=${getAccessToken()}`,
        topInfluencers: `v7/top-influencers?access-token=${getAccessToken()}`,
        postInfo: `v7/post-details?access-token=${getAccessToken()}`,
        download: `v7/download-data/add?access-token=${getAccessToken()}`,
        dashboardCreate: `v7/dashboard-service/dashboards/create?access-token=${getAccessToken()}`,
        dashboardClone: `v7/dashboard-service/dashboards/clone?access-token=${getAccessToken()}`,
        shareURL: `v7/dashboard-service/dashboards/share?access-token=${getAccessToken()}`,
        stopShareURL: `v7/dashboard-service/dashboards/share/stop?access-token=${getAccessToken()}`,
        generalTrends: `v0/data/country-wise`,
        socialInsights: `${"v7/social-insights?access-token=" + getAccessToken()}`,
        fbPageTokenList: `v7/facebook-insight-token/list?access-token=` + getAccessToken(),
        createFbPageToken: `v7/facebook-insight-token/create?access-token=` + getAccessToken(),
        add_cust_dash: `${"v7/graph-api/graph?access-token=" + getAccessToken()}`,
        update_chart: `${"v7/graph-api/update?access-token=" + getAccessToken()}`,
        "store-social-tokens": `v7/store-social-token?access-token=${getAccessToken()}`,
        post_comments: `v7/search?access-token=${getAccessToken()}`,
        block_source_meesage: "v1/block-source/get-message",
        update_user_details: `v7/user-service/user/${getUserId()}?access-token=${getAccessToken()}`,
        update_company_details: `/v7/company-service/company/${getCompanyId()}?access-token=${getAccessToken()}`,
        get_data_usage_historic: `v7/historic/historic-data-meter?access-token=${getAccessToken()}`,
        upload_photo: `v7/user-service/user/image/upload?access-token=${getAccessToken()}`,
        get_word_cloud_data: `v7/wordcloud-service/wordcloud/list?access-token=${getAccessToken()}`,
        delete_word_cloud_item: `v7/wordcloud-service/wordcloud/delete-word?access-token=${getAccessToken()}`,
        get_data_usage: `companies/get-data-usage?access-token=${getAccessToken()}`,
        get_data_countrywise: `v7/search?access-token=${getAccessToken()}`,
        company_service: `v7/company-service/company`,
        create_user: `v7/user-service/user?access-token=${getAccessToken()}`,
        update_user_management: `v7/user-service/user`,
        switch_account: `v7/user-service/user/switch-account`,
        get_company_teams: `v7/user-service/teams?include_members=1&access-token=${getAccessToken()}`,
        create_team: `v7/user-service/teams?access-token=${getAccessToken()}`,
        update_team: `v7/user-service/teams`,
        get_clients: `v7/list-active-company?access-token=${getAccessToken()}`,
        validate_token: `v7/validateToken?access-token=${getAccessToken()}`,
        tag_client: `v7/common/tag-company-ids-to-es-post?access-token=${getAccessToken()}`,
        dynamicTagsList: `v7/common/tag-manager/list?access-token=${getAccessToken()}`,
        addDynamicTags: `v7/common/tag-manager/add?access-token=${getAccessToken()}`,
        deleteDynamicTags: `v7/common/tag-manager/delete?access-token=${getAccessToken()}`,
        updateDynamicTags: `v7/common/tag-manager/update?access-token=${getAccessToken()}`,
        "add-note": `${"v7/graph-api/description/update?access-token=" + getAccessToken()}`,
        "add-subgraph-note": `${"v7/graph-description/save?access-token=" + getAccessToken()}`,
        "update-graph-order": `${"v7/meta/filters/update-order?access-token=" + getAccessToken()}`,
        save_custom_filters: `${"v7/custom-dashboard-filters?access-token=" + getAccessToken()}`,
        collection: "v7/collections",
        alerts: "v7/alerts",
        "publication-service": "v7/publication-service/publication",
        "block-source": "v7/block-service/source",
        "login-logs": "v7/common/login-log/list",
        reportsConfig: "/v7/admin/reports",
        getFbTokens: `${"v7/access-token-facebook?access-token=" + getAccessToken()}`,
        getIgTokens: `${"v7/access-token-instagram?access-token=" + getAccessToken()}`,
        getLkdnTokens: `${"v7/access-token-linkedin?access-token=" + getAccessToken()}`,
        toggleTokenStatus: `${"v7/token-service/tokens/status/change?access-token=" + getAccessToken()}`,
        storeLkdnToken: `${"linkedin-auth-callback?access-token=" + getAccessToken()}`,
        setViralityThreshold: `${"v1/company/update?access-token=" + getAccessToken()}`,
        spamRange: `${"v7/company-service/company/"}`,
        getFbComments: `${"v7/facebook/comments-list?access-token=" + getAccessToken()}`,
        addFbComments: `${"v7/facebook/fetch-comments?access-token=" + getAccessToken()}`,
        deleteFbComments: `${"v7/facebook/delete-post?access-token=" + getAccessToken()}`,
        getIgHashTags: `${"v7/instagram-account/list-account?access-token=" + getAccessToken()}`,
        addIgHashTags: `${"v7/instagram-account/add-hashtag?access-token=" + getAccessToken()}`,
        deleteIgHashTags: `${"v7/instagram-account/delete-account?access-token=" + getAccessToken()}`,
        queryBuilderCountryList: `${"v1/query-builder/country?access-token=" + getAccessToken()}`,
        comapnyMetaApi: `${"v7/meta?values=company&access-token=" + getAccessToken()}`,
        filter_service: `v7/filter-service`,
        dashboard_service: `v7/dashboard-service`,
        wordcloud_exclusion: `${"v7/wordcloud-service/wordcloud/add-word?access-token=" + getAccessToken()}`,
        get_notifications_list: `v7/notification-service/list?access-token=${getAccessToken()}`,
        set_notification_settings: `v7/user-service/user`,
        subscription: `v7/subscription-service`,
        mark_as_read: `v7/notification-service`,
        socialLogin: `auth-service/oauth`,
        email_verify: "auth-service/email-verification",
        forget_password: "auth-service/forget-password",
        reset_password: "auth-service/reset-password",
        sign_up: "auth-service/signup",
        sign_in: "auth-service/login",
        auth_service: "auth-service",
        validate_rule: `v7/admin/rule-management/v1/rule-validate?access-token=${getAccessToken()}`,
        social: `v7/social`,
        validate_account: `v7/social/validate-account-v2?access-token=${getAccessToken()}`,
        rule_create: `v7/admin/rule-management/v1/rule-create?access-token=${getAccessToken()}`,
        add_account: `v7/social/add-account?access-token=${getAccessToken()}`,
        progressbar_info: `v7/getting-started-service/get-progress?user_id=${getUserId()}`,
        update_progressbar: `v7/getting-started-service/configure-progress?access-token=${getAccessToken()}`,
        query_list: `v7/filter-service/filter/list?company_id=${getCompanyId()}`,
        datafetch_disable: `v7/admin/rule-management/v1/stop-gnip-subscription?access-token=${getAccessToken()}`,
        datafetch_enable: `v7/admin/rule-management/v1/start-gnip-subscription?access-token=${getAccessToken()}`,
        delete_account: `v7/social/delete-account?access-token=${getAccessToken()}`,
        delete_query: `api/v1/query-builder/delete`,
        rule_delete: `v7/admin/rule-management/v1/rule-delete/`,
        historic_list: `v7/historic/list-historic?access-token=${getAccessToken()}`,
        generate_volume: `v7/historic/get-estimate?access-token=${getAccessToken()}`,
        create_historic: `v7/historic/add?access-token=${getAccessToken()}`,
        supported_languages: `v7/translation-service/supported-google-translate-lang?access-token=${getAccessToken()}`,
        translate_text: `v7/translation-service/google-translate?access-token=${getAccessToken()}`,
        elastisearch_service: "v7/elasticsearch-service",
        smr_service: "v7/smr-service",
        configure_page_language: "v7/token-service/tokens/update",
        smp_service: "v7/smp-service",
        cxm_inbox: `v7/smr-service/tickets/list?access-token=${getAccessToken()}`,
        agent_list: `v7/company-service/company/${getCompanyId()}`,
        user_list: `v7/smr-service/messaging/get-public-pages?access-token=${getAccessToken()}`,
        assign_agent: `v7/smr-service/post/assign?access-token=${getAccessToken()}`,
        auto_assign: `/v7/smr-service/post/auto-assign?access-token=${getAccessToken()}`,
        reply_comment: `v7/smr-service/response/send?access-token=${getAccessToken()}`,
        comment_thred: `v7/smr-service/conversations`,
        cxm_pages_list: `v7/smr-service/pages/list`,
        twostep_verification: `v7/company-service/company/${getCompanyId()}?access-token=${getAccessToken()}`,
        role_update: `v7/user-service/user/roles/update?access-token=${getAccessToken()}`,
        cxm_enable: `v7/smr-service/qb/cxm-enable?access-token=${getAccessToken()}`,
        cxm_disable: `v7/smr-service/qb/cxm-disable?access-token=${getAccessToken()}`,
        cxm_fb_store_token: `v7/smr-service/oauth/facebook/access_token?access-token=${getAccessToken()}`,
        // twitter_oauth_token: `v7/cxm-service/oauth/twitter/request_token?access-token=${getAccessToken()}`,
        // twitter_authenticate: `v7/cxm-service/oauth/twitter/access_token?access-token=${getAccessToken()}`,
        image_analytics: `v7/image-analytics-service`,
        msg_status_change: `v7/smr-service/response/close?access-token=${getAccessToken()}`,
        cxm_settings: `v7/smr-service/settings`,
        profile_setup: `v7/company-service/company/profile/setup/v2?access-token=${getAccessToken()}`,
        get_industries: "v7/industry-service/get-all-industries",
        support_email: `common-service/send-support-email`,
        get_progress: `/v7/getting-started-service/v2/get-progress?access-token=${getAccessToken()}`,
        configure_progress: `/v7/getting-started-service/v2/configure-progress?access-token=${getAccessToken()}`,
        hide_getting_started: `/v7/getting-started-service/v2/configure-progress?access-token=${getAccessToken()}`,
        store_ig_insights_page: `v7/instagram-insight-token/create?access-token=${getAccessToken()}`,
        ig_pages_List: `v7/instagram-insight-token/list?access-token=${getAccessToken()}`,
        ig_insights_metrics: `v7/instagram-insights?access-token=${getAccessToken()}`,
        twitter_insights_oauth_token: `v7/token-service/oauth/twitter/request_token?access-token=${getAccessToken()}&feature_type=insight`,
        twitter_insights_authenticate: `v7/token-service/oauth/twitter/store-token?access-token=${getAccessToken()}&feature_type=insight`,
        tw_pages_List: `v7/token-service/tokens/list?access-token=${getAccessToken()}&platform=twitter`,
        twitterInsights: "v7/insight-service/twitter/get-insight",
        store_central_social_token: `v7/token-service/oauth/facebook/store-token?access-token=${getAccessToken()}`,
        twitter_oauth_token: `v7/token-service/oauth/twitter/request_token?access-token=${getAccessToken()}`,
        tiktok_authenticate: `v7/token-service/oauth/tiktok/store-token?access-token=${getAccessToken()}`,
        linkedin_authenticate: `v7/token-service/v2/oauth/linkedin/store-token?access-token=${getAccessToken()}`,
        get_linkedin_pages: `v7/token-service/oauth/linkedin/access_token`,
        twitter_authenticate: `v7/token-service/oauth/twitter/store-token?access-token=${getAccessToken()}`,
        social_token_list: `v7/token-service/tokens/list?access-token=${getAccessToken()}&company_id=${getLiteCompanyId()}`,
        campaign_list: `v7/smp-service/campaign/list?company_id=${getLiteCompanyId()}`,
        campaign_url: `v7/smp-service/campaign`,
        ad_account_list: `v7/token-service/ad_accounts/list?access-token=${getAccessToken()}&`,
        competitor_list: `v7/social/list-account?access-token=${getAccessToken()}`,
        delete_competitor: `v7/social/delete-account?access-token=${getAccessToken()}`,
        competitor_follower: `v7/social/account/followers?access-token=${getAccessToken()}`,
        email_post: `v7/email-service/send-email?access-token=${getAccessToken()}`,
        gmb_get_token: `v7/token-service/oauth/gmb/access_token?access-token=${getAccessToken()}`,
        gmb_get_store_token: `v7/token-service/oauth/gmb/store-token?access-token=${getAccessToken()}`,
        smr_rules: `v7/smr-service/rules`,
        tiktok_followers: `v7/insight-service/tiktok/follower-growth-overtime`,
        linkedin_followers: `v7/insight-service/linkedin/follower-growth-overtime`,
        linkedin_followers_by_facet: `v7/insight-service/linkedin/followers-by-facet`,
        linkedin_insight_service: `v7/insight-service/linkedin`,
        cxm_inbox_status: `v7/smr-service/status/list`,
        sf_status: `v7/smr-service/integrations/salesforce/status/list`,
        sf_updated_status: `v7/smr-service/status/group/configure?access-token=${getAccessToken()}`,
        sf_create_store: `v7/smr-service/integrations/configs`,
        sf_token: `v7/smr-service/integrations/tokens/store?access-token=${getAccessToken()}`,
        sf_setup_status: `v7/smr-service/integrations/salesforce/setup?access-token=${getAccessToken()}`,
        user_service: `v7/user-service/user`,
        // gmb_account: `v7/mybusiness.googleapis.com/v1/accounts?access-token=${getAccessToken()}`,
        upload_service: "v7/upload-service",
        server_side_events: "sse/subscribe",
        youtube_opa_insights: `v7/insight-service/youtube/get-insight?access-token=${getAccessToken()}`,
        youtube_opa_total_subs: `v7/insight-service/youtube/get-subscriber-count`,
        youtube_get_token: `v7/token-service/oauth/youtube/access_token?access-token=${getAccessToken()}`,
        youtube_get_store_token: `v7/token-service/oauth/youtube/store-token?access-token=${getAccessToken()}`,
        smr_survey: "v7/smr-service/survey/templates",
        revokeToken: `${"v7/token-service/oauth/revoke-token?access-token=" + getAccessToken()}`,
        save_filter_data_usage: `${"v7/company-service/data-usage-filter?access-token=" + getAccessToken()}`,
        token_service_playstore: `v7/token-service/oauth/playstore`,
        top_influencers_chart: `v7/top-influencers?access-token=${getAccessToken()}`,
        // recommendation: `v7/recommendation-service/recommendation/generate?access-token=${getAccessToken()}`,
        recommendation: `v7/recommendation-service/recommendation`,
        recommendation_filter: `v7/recommendation-service/filter`,
        platform_post_list: `v7/smr-service/platform-post-list`,
        platform_comment_post_url: `v1/smr-service/filters`,
        facebook_impression: `v7/social-insights/agreegators`,
        appstore_token: `v7/token-service/oauth/appstore`,
        rule_engine: `v7/automation-service/rules`,
        smr_delete_message: "v7/smr-service/messaging",
        telegram_token: `v7/token-service/oauth/telegram`,
        smr_keyword: "v7/smr-service/sync/listening-smr/rule/config",
        email_ticket: `v7/smr-service/messages/send?access-token=${getAccessToken()}`,
        create_task: `v7/task-service/tasks`,
        ai_modal: `v7/smr-service/knowledge_base?access-token=${getAccessToken()}`,
        download_list: `v7/download-data/list`,
        react_to_post: `v7/smr-service/messaging/react-post?access-token=${getAccessToken()}`,
        youtube_trends: `v7/company-service/youtube-trends?`,
        youtube_subscriber: `/v7/youtube/channel/subscriber?access-token=${getAccessToken()}`,
        smr_mark_msg_as: "v7/smr-service/tickets/mark",

        // twitter trends
        twitter_trends_get_top_trends_legacy: `v7/twitter-trends/getTopTrends-legacy?access-token=${getAccessToken()}`,
        twitter_trends_get_top_trends: `v7/twitter-trends/getTopTrends?access-token=${getAccessToken()}`,
        twitter_trends_get_top_trends_overtime: `v7/twitter-trends/getTopTrends/overtime?access-token=${getAccessToken()}`,
        twitter_trends_get_top_trends_overtime_using_comparison: `v7/twitter-trends/getTopTrends/overtime/usingComparison?access-token=${getAccessToken()}`,
    };

    return urls[key] ? process.env.REACT_APP_URL + urls[key] : null;
};

// const getPhpUrls = (key, staging) => {
//     let baseUrl = staging ? "//api2020stage.radarr.com/" : "//api2020.radarr.com/";

//     let urls = {
//         bulk_sentiment_update: `api/v1/node-routing/route?access-token=${getAccessToken()}`,
//         bulk_mark_irr_update: `api/v1/node-routing/route?access-token=${getAccessToken()}`,
//         // 'collections_list': `api/v1/collection/list?access-token=${getAccessToken()}`,
//         // 'add_to_collection': `api/v1/collection/create?access-token=${getAccessToken()}`,
//         teams_i_belong_to: `api/v1/team/teams-i-belong-to?access-token=${getAccessToken()}`,
//         email_post: `api/v1/email/send?access-token=${getAccessToken()}`,
//         add_spark: `api/v1/spark/upsert?access-token=${getAccessToken()}`,
//         wordcloud: `api/v1/common/word-cloud?access-token=${getAccessToken()}`,
//         post_comments: `api/v1/common/search?access-token=${getAccessToken()}`,
//         wordcloud_exclude: `api/v1/insights/word-exclusion?access-token=${getAccessToken()}`,
//         query_builder: `api/v1/query-builder/create-subscription`,
//         // 'queryBuilderCountryList': `${"api/v1/query-builder/country?access-token=" +getAccessToken()}`,
//     };

//     return urls[key] ? baseUrl + urls[key] : null;
// };

export const getAuthUrls = (key) => {
    let urls = {
        sign_in: "auth-service/login",
        auth_service: "auth-service",
        socialLogin: `auth-service/oauth`,
        email_verify: "auth-service/email-verification",
        forget_password: "auth-service/forget-password",
        reset_password: "auth-service/reset-password",
        sign_up: "auth-service/signup",
    };

    return urls[key] ? process.env.REACT_APP_URL + urls[key] : null;
};
